<template>
  <div class="container">
    <Sidebar></Sidebar>
    <nav class="nav-extended blue-nav">
      <div class="nav-wrapper">
        <span class="nav-title">Settings</span>
      </div>
      <div class="nav-content">
        <ul class="tabs tabs-transparent" id="settingsTabs">
          <li class="tab">
            <a href="#general" class="active">General</a>
          </li>
          <li class="tab" v-if="admin">
            <a href="#plan" >Plan</a>
          </li>
          <li class="tab">
            <a href="#analytics">Analytics</a>
          </li>
        </ul>
      </div>
    </nav>
    <!-- <div id="servicebot-management-form"></div>
    <div class="progress" v-if="loading">
      <div class="indeterminate"></div>
    </div>-->

    <!-- General settings  -->
    <div id="general" v-if="!loading">
      <ul class="collection s12">
        <li class="collection-item row valign-wrapper">
          <div class="col s9">
            <div v-if="!nameChanging">
              <div>{{ settings.name }}</div>
              <span class="author">Name</span>
              <div class="error" v-if="nameError">{{ nameError }}</div>
            </div>
            <div v-else>
              <input
                id="nameInput"
                type="text"
                placeholder="name"
                v-model="settings.name"
                autocomplete="off"
                autofocus
                required
              />
            </div>
          </div>
          <div class="col s3 right-align right">
            <div v-if="nameChanging">
              <button
                class="btn-flat white waves-effect blue-text"
                v-on:click="hideNameChange"
              >CANCEL</button>
              <button class="btn-flat white waves-effect blue-text" v-on:click="updateName">APPLY</button>
            </div>
            <div v-else>
              <button
                class="btn-flat white waves-effect blue-text"
                v-on:click="showNameChange"
              >CHANGE</button>
            </div>
          </div>
        </li>
        <li class="collection-item row valign-wrapper">
          <div class="col s12">
            <div>{{ settings.email }}</div>
            <span class="author">Email</span>
          </div>
        </li>
        <li class="collection-item row valign-wrapper">
          <div class="col s9">
            <div>Password</div>
          </div>
          <div class="col s3 right-align">
            <router-link
              class="btn-flat white waves-effect blue-text"
              v-bind:to="{path: 'reset_password', query: {username: settings.email}}"
            >CHANGE</router-link>
          </div>
        </li>
      </ul>
    </div>
    <div id="plan">
      <div v-if="!stripeLoading && !plan" class="center">
          <span class="plantext">A plan for everyone</span>
          <h5 class="subplan">From solo creators, to maker spaces, to global businesses, 
            you can show the world how to do anything with fyiio. 
          </h5>
          <div style="height:42px">&nbsp;</div>
          
            <table class="freetable talltable">
              <tr>
                <td id="free1" >
                  <h2 class="center freetext" style="color:white">Free</h2>
                </td>
                <td id="free2" >
                  <h6 class="left create-a-beautiful" style="color:white">Create a beautiful, accessible, and shareable<br> home for all your how-to content.</h6>
                </td>
                <td id="free3">
                  <span style="color:white;position:relative;left:80px;top:50px">Current Plan</span>
                  <img class="center" src="../../assets/free-tier-background.svg">
                </td>
              </tr>
            </table>
          
          
             <table class="freetable widetable">
              <tr>
                <td>
                  <h2 class="center " style="color:white">Free</h2>
                </td>
              </tr>
              <tr>
                <td >
                  <h6 class="center" style="color:white">Create a beautiful, accessible, and shareable<br> home for all your how-to content.</h6>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="xcontainer">
                    <img src="../../assets/free-tier-background.svg" alt="Snow" style="width:100%;">
                    <div class="xcentered">Current Plan</div>
                  </div>
                </td>
              </tr>
            </table>
            
          
          <div style="height:42px">&nbsp;</div>
          <stripe-pricing-table :pricing-table-id="stripe_pricing_id"
            :publishable-key="stripe_pricing_pk" :customer-email="settings.email">
            </stripe-pricing-table>
            <div style="height:42px">&nbsp;</div>
           <a href="https://fyi.io/pricing" target="_blank" class="btn waves-effect waves-light fyifab right"><i class="material-icons left">help</i>Learn more about our pricing plans</a>
      </div>
      <div v-if="!stripeLoading && plan">
        <div class="plan-details center">
              <h2 class="plantext">You're on the {{planName()}} plan</h2>
              <p class="itcosts">It costs ${{planAmount}} per {{planMonthly?"month":"year"}}</p>
              <p v-if="planMonthly" class="yousavi"><b>You could be saving ${{planSaving()}} a year by switching to yearly billing.</b></p>
              <p class="yousavi" v-else>You're saving ${{planSaving()}} with yearly pricing.</p>
              <p
                v-if="!plan.cancel_at_period_end"
              >Renews on {{formatDate(new Date(plan.current_period_end * 1000))}}</p>
              
              <p v-if="plan.cancel_at_period_end">
                PLAN CANCELED
                <br />
                Ending on {{formatDate(new Date(plan.current_period_end * 1000))}}
              </p>
              <div >
                <p class="center">
                  <br>
                  <a class="waves-effect waves-light btn tooltipped" style="background-color:#27aae1" :href="billingPortalLink()" target="_new" data-position="right" data-tooltip="Opens in new window"> 
                Access Billing Portal</a>
                </p>
                <div style="height:300px">&nbsp;</div>
                <a href="https://fyi.io/pricing" style="position:relative;bottom:0;" class="btn waves-effect waves-light fyifab right" target="_blank"><i class="material-icons left">help</i>Learn more about our pricing plans</a>
              </div>
            </div>
         </div>
      </div>
      
<!--{{JSON.stringify(plan)}}-->
    
    <div id="analytics">
      <h3 class="collection-header">
        <span v-if="!time_frame">Select time frame</span>
        <span v-if="time_frame">Select option below</span>

        <select id="time-frame-selector" v-model="time_frame" v-on:change="loadArticles">
          <option disabled value>Time frame</option>
          <option value="week">This week</option>
          <option value="month">This month</option>
          <option value="last30">Last 30 days</option>
          <option value="year">This year</option>
          <option value="alltime">All time</option>
        </select>
      </h3>
      <div class="progress" v-if="analytics_loading">
        <div class="indeterminate"></div>
      </div>
      <div class="analytics-buttons">
        <div style="display: inline-block;">
          <span class="btn blue disabled" v-if="report_requested">Visual report requested</span>

          <span
            class="btn blue"
            @click="requestReport"
            v-if="!report_requested"
            v-bind:class="{ disabled: analytics_loading || !report }"
          >Request visual report</span>
          <br />
          <span class="may-take">may take up to 24 hours to generate</span>
        </div>
        <div class="or">or</div>
        <div>
          <span
            class="btn blue"
            @click="downloadCSV"
            v-bind:class="{ disabled: analytics_loading || !report }"
          >Download CSV</span>
        </div>
      </div>
      <div v-if="false" class="table-wrapper">
        <!--<button class="btn-flat white waves-effect blue-text" v-on:click="exportData" >-->
        <!--  Export-->
        <!--</button>-->

        <table id="analytics-table">
          <thead>
            <tr>
              <th v-for="header in table_headers" :key="header">{{header}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, row_index) in table_rows" :key="row_index">
              <td v-for="(col, col_index) in row" :key="col_index">{{col}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar";
import cognitoAuth from "@/plugins/cognito";
import GqlQuery from "@/plugins/gql";
import StripeApi from "@/plugins/stripeApi";
import AnalyticsApi from "@/plugins/analyticsApi";
let converter = require("json-2-csv");
var _ = require("lodash");
export default {
  mounted() {
    M.AutoInit();
    var self = this;
    this.loadPlanData();
  },
  updated() {
    M.AutoInit();
  },
  name: "Tutorials",
  data() {
    var formatDate = function(date) {
      var monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      var day = date.getDate();
      var monthIndex = date.getMonth();
      var year = date.getFullYear();
      return monthNames[monthIndex] + " " + day + ", " + year;
    };

    return {
      articles: [],
      report: false,
      report_requested: false,
      lookup: false,
      table_headers: [
        "date",
        "category",
        "action",
        "tutorial",
        "step",
        "step index",
        "event count",
        "seconds watched *"
      ],
      table_rows: [],
      time_frame: false,
      loading: true,
      stripeLoading: true,
      analytics_loading: false,
      nameChanging: false,
      nameError: false,
      plan: false,
      planS: false,
      show_details: false,
      formatDate: formatDate,
      selectPlan: false,
      admin: false,
      customer_id: false,
      messagen: "",
      stripe_pricing_id: process.env.STRIPE_PRICING_TABLE_ID,
      stripe_pricing_pk: process.env.STRIPE_PRICING_TABLE_PK,
      settings: {
        name: "",
        cancel_name: "",
        email: "",
        password_changed: "",
        customer_id: false,
        email_verified: false
      }
    };
  },
  computed: {
    planMonthly(){
      let self=this;
      if(!self.stripeLoading && self.plan){
        if(self.plan.plan.interval=="month"){
          return true;
        }else{
          return false;
        }
      }
    },
    planAmount(){
      let self=this;
      if(!self.stripeLoading && self.plan){
        if(self.plan.plan.amount){
          return self.plan.plan.amount/100
        }else{
          return 0
        }
      }
    },
    
  }, 
  methods: {
    planSaving(){
      let self=this;
      let planName=self.planName()
      switch(planName) {
        case "Maker":
          return "69"
          break;
        case "Team":
          return "600"
          break;
        case "Company":
          return "1,200"
        default:
          return "You are already on the free plan!"
      }
    },
    planName() {
          let self=this;
          if(self.plan){
            let plan=self.plan.plan
            console.log(self.plan.plan)
            let amount=plan.amount/100
            if(plan.nickname==null){
              if(amount<100){
                return "Maker"
              }else if(amount>100 && amount<500){
                return "Team"
              }else{
                return "Company"
              }
            }
          }else{
            return "Free"
          }   
    },
    
    billingPortalLink() {
      let self=this;
      return `${process.env.STRIPE_BILLING_LINK}?prefilled_email=` + encodeURIComponent(self.settings.email)
    },
    loadPlanData() {
      var self = this;
      ``;
      cognitoAuth.getUserAttributes(function(err, user_attributes) {
        self.settings.name = user_attributes.name;
        self.settings.cancel_name = user_attributes.name;
        self.settings.email = user_attributes.email;
        self.settings.email_verified = user_attributes.email_verified;
        self.charges = false;
        self.loading = false;
        self.organization_id = false;

        if (user_attributes["custom:method_of_boarding"] == "admin") {
          self.admin = true;
        } else {
          var elem = document.querySelector("#settingsTabs");
          var instance = M.Tabs.getInstance(elem);
          // instance.select('general');
          return;
        }

        if (user_attributes["custom:organization_id"]) {
          self.organization_id = user_attributes["custom:organization_id"];
          GqlQuery.getOrganization(function(err, organization) {
            organization.then(org => {
              var customer_id = org.data.organizations[0].customer_id;
              if (customer_id && customer_id != "null") {
                self.customer_id = customer_id;
                self.selectPlan = false;
                self.getCustomer();
              } else {
                var elem = document.querySelector("#settingsTabs");
                var instance = M.Tabs.getInstance(elem);
                // instance.select('general');
                self.selectPlan = true;
                self.stripeLoading=false;
              }
            });
          });
        }
      });
    },
    striper(){
      window.open("https://buy.stripe.com/bIY2aA3TT6WK99u8ww")
    },
    toggleDetails() {
      this.show_details = !this.show_details;
    },
    togglePlanSelection() {
      this.selectPlan = !this.selectPlan;
    },
    getCustomer() {
      console.log("entering getCustomer")
      var self = this;
      var body = JSON.stringify({ customer_id: self.customer_id });
      StripeApi.call("getCustomer", body, function(err, response) {
        self.plan = response.subscriptions.data[0];
        self.card = response.sources.data[0];
        self.stripeLoading=false;
        console.log("Setting getCUstomer to ", self.stripeLoading)
      });

      StripeApi.call("getCustomerHistory", body, function(err, response) {
        self.charges = response.data;
      });
    },
    switchToPlan(new_plan) {
      var self = this;
      self.loading = true;
      var body = JSON.stringify({
        coupon: self.messagen,
        customer_id: self.customer_id,
        subscription_id: self.plan.id,
        new_plan: new_plan
      });
      StripeApi.call("switchPlan", body, function(err, response) {
        self.plan = response;
        self.loading = false;
        self.selectPlan = false;
        GqlQuery.updateOrgAccountDetails(
          {
            id: self.organization_id,
            plan: new_plan,
            customer_id: self.customer_id
          },
          (err, result) => {
            if (err) {
              this.error = err;
            } else {
              result.then(r => {
                M.toast({ html: "Successfully switched plans!" }, 4000);

                console.log("account updated");
              });
            }
          }
        );
      });
    },
    cancelSubscription() {
      var self = this;
      self.loading = true;
      var body = JSON.stringify({
        customer_id: self.customer_id,
        subscription_id: self.plan.id
      });
      StripeApi.call("cancelSubscription", body, function(err, response) {
        self.plan = response;
        self.loading = false;
      });
    },
    checkout(plan) {
      var self = this;
      // this.loading = true;

      var params = {
        name: "Subscribe",
        currency: "USD",
        name: "fyiio inc",
        email: this.settings.email,
        description: "up to 1000 views per month",
        amount: 29999,
        token: token => {
          self.loading = true;
          StripeApi.call(
            "createSubscription",
            JSON.stringify({ token: token, plan: plan, coupon: self.messagen }),
            function(err, response) {
              GqlQuery.updateOrgAccountDetails(
                {
                  id: self.organization_id,
                  plan: plan,
                  customer_id: response.customer
                },
                (err, result) => {
                  if (err) {
                    this.error = err;
                  } else {
                    
                    result.then(r => {
                      setTimeout(function() {
                        self.loading = false;
                        self.loadPlanData();
                      }, 500);
                    });
                  }
                }
              );
            }
          );
        }
      };
      if (plan == "apollo") {
        params = Object.assign(params, {
          amount: 24900,
          description: "apollo plan"
        });
      } else if (plan == "dragon") {
        params = Object.assign(params, {
          amount: 49900,
          description: "dragon plan"
        });
      } else if (plan == "gemini") {
        params = Object.assign(params, {
          amount: 0,
          description: "gemini plan"
        });
      } else if (plan == "test") {
        params = Object.assign(params, {
          amount: 100,
          description: "test"
        });
      }
      //console.log(params);
      this.$checkout.open(params);
    },
    updateCardDetails() {
      var self = this;
      this.$checkout.open({
        name: "Update Card Details",
        currency: "USD",
        panelLabel: "UPDATE",
        description: "",
        email: this.settings.email,
        token: token => {
          var body = JSON.stringify({
            customer_id: self.customer_id,
            subscription_id: self.plan.id,
            token: token
          });
          StripeApi.call("updateCardDetails", body, function(err, response) {
            self.loading = false;
            self.card = response.sources.data[0];
            self.getCustomer();
            M.toast({ html: "Successfully updated payment info!" }, 4000);
          });
        }
      });
    },
    updateOrgAccountDetails: function(id, plan, customer_id, cb) {
      var self = this;
      GqlQuery.updateOrgAccountDetails(id, plan, customer_id, (err, result) => {
        if (err) {
          this.error = err;
        } else {
          this.nameChanging = false;
          self.customer_id = customer_id;
          self.getCustomer();
        }
      });
    },
    showNameChange: function(event) {
      this.settings.cancel_name = this.settings.name;
      this.nameChanging = true;
      this.nameError = false;
    },
    hideNameChange: function(event) {
      this.settings.name = this.settings.cancel_name;
      this.nameChanging = false;
    },
    updateName: function() {
      this.$cognitoAuth.updateName(this.settings.name, (err, result) => {
        if (err) {
          this.error = err;
          M.toast(
            {
              html:
                "There was an error updating name, please try again or contact Fyiio support!"
            },
            4000
          );
        } else {
          M.toast({ html: "Successfully updated name!" }, 4000);

          this.nameChanging = false;
        }
      });
    },

    loadAnalyticsData() {
      var self = this;
      self.report_requested = false;
      cognitoAuth.getUserAttributes(function(err, user_attributes) {
        if (user_attributes["custom:organization_id"]) {
          self.organization_id = user_attributes["custom:organization_id"];
          AnalyticsApi.call(
            "getReport",
            {
              organization_id: user_attributes["custom:organization_id"],
              time_frame: self.time_frame
            },
            function(err, response) {
              self.report = response.reports[0];
              self.report_preview = JSON.stringify(self.report, null, "\n\t");
              self.buildTable();
            }
          );
        }
      });
    },

    requestReport() {
      var self = this;
      self.report_requested = true;
      var reporting_csv = [];
      reporting_csv.push(self.table_headers);
      _.each(self.table_rows, function(a) {
        reporting_csv.push(a);
      });
      AnalyticsApi.call(
        "requestReport",
        {
          csv: reporting_csv,
          user_email: self.settings.email
        },
        function(err, response) {
          if (err) {
            console.log("request error: ", err);
          }
          M.toast(
            {
              html: "Got it! We'll be in touch within 24 hours with your report"
            },
            4000
          );
        }
      );
    },

    loadArticles() {
      var self = this;
      self.analytics_loading = true;
      GqlQuery.getAnalyticsLookup(function(err, response) {
        if (err) {
          self.error = err;
        }
        response.then(function(val) {
          var articles = val.data.articles;
          var org_ids = articles.map(function(a) {
            return a.organization_id;
          });
          var active_articles = articles.filter(function(a) {
            return a.organization_id == "fcdac900-d58a-11e8-927b-27dc03388e09";
          });

          var lookup = {
            chapters: {},
            steps: {}
          };

          var chapter_ids = [];
          _.each(articles, function(a) {
            _.each(a.chapters, function(c) {
              chapter_ids.push(c.id);
              lookup.chapters[c.id] = c.title.replace(",", " ");
            });
          });

          _.each(chapter_ids, function(cid) {
            GqlQuery.getChapterById(cid, function(e, r) {
              r.then(function(rr) {
                _.each(rr.data.chapter.steps, function(s) {
                  lookup.steps[s.id] = s.title.replace(", ", " ");
                });
                self.lookup = lookup;
                self.lookup_preview = JSON.stringify(lookup, null, "\t");
              });
            });
          });
        });
        self.loadAnalyticsData();
      });
    },

    buildTable() {
      var self = this;
      var table = [];
      _.each(self.report.data.rows, function(row) {
        var new_row = [];
        var i = 0;

        _.each(row.dimensions, function(d) {
          if (i == 3) {
            // look up chapter name
            d = self.lookup.chapters[d] || d;
          } else if (i == 4) {
            // look up step name
            if (d == -1 && row.dimensions[1] == "tutorial") {
              // don't report step name if tutorial and -1
              d = null;
            }
            d = self.lookup.steps[d] || d;
          } else if (i == 5) {
            if (d == -1 && row.dimensions[1] == "tutorial") {
              // don't report step name if tutorial and -1
              d = null;
            }
            if (d == -1 && row.dimensions[1] == "step") {
              // for the case of the initally loaded intro step
              d = 0;
            }
          } else if (i == 0) {
            d = d.replace(/(\d{4})(\d{2})(\d{2})/g, "$1-$2-$3");
          }
          new_row.push(d);
          i++;
        });
        _.each(row.metrics[0].values, function(m) {
          new_row.push(m);
        });

        if (row.dimensions[1] == "step" && row.dimensions[4] == -1) {
          // don't push new row
        } else {
          table.push(new_row);
        }
      });
      self.analytics_loading = false;
      self.table_rows = table;
    },
    downloadCSV() {
      M.toast({ html: "Download starting" }, 4000);

      function download(filename, text) {
        var element = document.createElement("a");
        element.setAttribute(
          "href",
          "data:text/plain;charset=utf-8," + encodeURIComponent(text)
        );
        element.setAttribute("download", filename);
        element.style.display = "none";
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }
      var self = this;
      var csv_array = self.table_rows;
      csv_array.unshift(self.table_headers);
      converter.json2csv(
        csv_array,
        function(err, csv) {
          csv = csv.replace(/0.*\n/, "").trim();
          download("fyiio-analytics.csv", csv);
        },
        {}
      );
    }
  },
  components: {
    Sidebar
  }
};
</script>

<style scoped>
ul.collection {
  border: none;
}
.dropdown-content {
  min-height: 20px;
  min-width: 250px;
}
.plan-info {
  color: #939598;
  font-size: 14px;
  margin-bottom: 0;
}
.plan.card .card-content {
  margin-bottom: 0;
}
.plan.card .card-title {
  font-size: 48px;
  color: #58595b;
}
.error {
  color: red;
}
.plan.card {
  max-width: 450px;
  margin-bottom: 8em;
}
.card-row {
  display: flex;
}
.plan-img {
  max-width: 150px;
  margin: 1em;
}
.plan h2 {
  font-size: 38px;
  font-weight: 500;
  padding-top: 0px;
  margin-top: 15px;
  color: #58595b;
}
.plan p {
  margin-bottom: 0;
  margin-top: 5px;
  color: #58595b;
}
.plan a {
  color: #40abe1;
}
.account-links li {
  cursor: pointer;
  color: #40abe1;
  margin-top: 1em;
}
.billing-details li {
  margin-left: 1em;
  color: #58595b;
  cursor: default;
  margin-top: 0.2em;
}
#settingsTabs {
  overflow: hidden;
}

.plan-selection {
  display: flex;
}
.plan-selection .plan {
  flex-basis: 32%;
  text-align: center;
  border: 1px solid gray;
  margin: 1em;
}
.plan-selection a {
  color: white;
}
.plan-details .btn {
  margin-bottom: 1em;
  bottom: 0px;
}
.marketing {
  text-align: right;
  padding-right: 5em;
}

.plan-top {
  color: white;
  background-color: gray;
  padding: 1em;
}
.plan-name {
  font-size: 24px;
}
.plan-cost {
  font-size: 48px;
}

.trial {
  background: -moz-linear-gradient(
    to top,
    rgba(89, 90, 92, 1) 0%,
    rgba(146, 148, 151, 1) 100%
  );
  background: -webkit-linear-gradient(
    to top,
    rgba(89, 90, 92, 1) 0%,
    rgba(146, 148, 151, 1) 100%
  );
  background: -o-linear-gradient(
    to top,
    rgba(89, 90, 92, 1) 0%,
    rgba(146, 148, 151, 1) 100%
  );
  background: -ms-linear-gradient(
    to top,
    rgba(89, 90, 92, 1) 0%,
    rgba(146, 148, 151, 1) 100%
  );
  background: linear-gradient(
    to top,
    rgba(89, 90, 92, 1) 0%,
    rgba(146, 148, 151, 1) 100%
  );
}

.trial.btn {
  min-width: 172px;
  background: -moz-linear-gradient(
    to right,
    rgba(89, 90, 92, 1) 0%,
    rgba(146, 148, 151, 1) 100%
  );
  background: -webkit-linear-gradient(
    to right,
    rgba(89, 90, 92, 1) 0%,
    rgba(146, 148, 151, 1) 100%
  );
  background: -o-linear-gradient(
    to right,
    rgba(89, 90, 92, 1) 0%,
    rgba(146, 148, 151, 1) 100%
  );
  background: -ms-linear-gradient(
    to right,
    rgba(89, 90, 92, 1) 0%,
    rgba(146, 148, 151, 1) 100%
  );
  background: linear-gradient(
    to right,
    rgba(89, 90, 92, 1) 0%,
    rgba(146, 148, 151, 1) 100%
  );
}

.apollo {
  background: -moz-linear-gradient(
    to bottom right,
    rgba(64, 171, 225, 1) 0%,
    rgba(83, 168, 158, 1) 100%
  );
  background: -webkit-linear-gradient(
    to bottom right,
    rgba(64, 171, 225, 1) 0%,
    rgba(83, 168, 158, 1) 100%
  );
  background: -o-linear-gradient(
    to bottom right,
    rgba(64, 171, 225, 1) 0%,
    rgba(83, 168, 158, 1) 100%
  );
  background: -ms-linear-gradient(
    to bottom right,
    rgba(64, 171, 225, 1) 0%,
    rgba(83, 168, 158, 1) 100%
  );
  background: linear-gradient(
    to bottom right,
    rgba(64, 171, 225, 1) 0%,
    rgba(83, 168, 158, 1) 100%
  );
}
.apollo.btn {
  background: -moz-linear-gradient(
    to right,
    rgba(64, 171, 225, 1) 0%,
    rgba(83, 168, 158, 1) 100%
  );
  background: -webkit-linear-gradient(
    to right,
    rgba(64, 171, 225, 1) 0%,
    rgba(83, 168, 158, 1) 100%
  );
  background: -o-linear-gradient(
    to right,
    rgba(64, 171, 225, 1) 0%,
    rgba(83, 168, 158, 1) 100%
  );
  background: -ms-linear-gradient(
    to right,
    rgba(64, 171, 225, 1) 0%,
    rgba(83, 168, 158, 1) 100%
  );
  background: linear-gradient(
    to right,
    rgba(64, 171, 225, 1) 0%,
    rgba(83, 168, 158, 1) 100%
  );
}

.dragon {
  background: -moz-linear-gradient(
    to bottom right,
    rgba(83, 168, 157, 1) 0%,
    rgba(232, 113, 165, 1) 100%
  );
  background: -webkit-linear-gradient(
    to bottom right,
    rgba(83, 168, 157, 1) 0%,
    rgba(232, 113, 165, 1) 100%
  );
  background: -o-linear-gradient(
    to bottom right,
    rgba(83, 168, 157, 1) 0%,
    rgba(232, 113, 165, 1) 100%
  );
  background: -ms-linear-gradient(
    to bottom right,
    rgba(83, 168, 157, 1) 0%,
    rgba(232, 113, 165, 1) 100%
  );
  background: linear-gradient(
    to bottom right,
    rgba(83, 168, 157, 1) 0%,
    rgba(232, 113, 165, 1) 100%
  );
}
.dragon.btn {
  background: -moz-linear-gradient(
    to right,
    rgba(83, 168, 157, 1) 0%,
    rgba(232, 113, 165, 1) 100%
  );
  background: -webkit-linear-gradient(
    to right,
    rgba(83, 168, 157, 1) 0%,
    rgba(232, 113, 165, 1) 100%
  );
  background: -o-linear-gradient(
    to right,
    rgba(83, 168, 157, 1) 0%,
    rgba(232, 113, 165, 1) 100%
  );
  background: -ms-linear-gradient(
    to right,
    rgba(83, 168, 157, 1) 0%,
    rgba(232, 113, 165, 1) 100%
  );
  background: linear-gradient(
    to right,
    rgba(83, 168, 157, 1) 0%,
    rgba(232, 113, 165, 1) 100%
  );
}

.gemini {
  background: -moz-linear-gradient(
    to bottom right,
    rgba(232, 113, 165, 1) 0%,
    rgba(246, 176, 64, 1) 100%
  );
  background: -webkit-linear-gradient(
    to bottom right,
    rgba(232, 113, 165, 1) 0%,
    rgba(246, 176, 64, 1) 100%
  );
  background: -o-linear-gradient(
    to bottom right,
    rgba(232, 113, 165, 1) 0%,
    rgba(246, 176, 64, 1) 100%
  );
  background: -ms-linear-gradient(
    to bottom right,
    rgba(232, 113, 165, 1) 0%,
    rgba(246, 176, 64, 1) 100%
  );
  background: linear-gradient(
    to bottom right,
    rgba(232, 113, 165, 1) 0%,
    rgba(246, 176, 64, 1) 100%
  );
}
.gemini.btn {
  background: -moz-linear-gradient(
    to right,
    rgba(232, 113, 165, 1) 0%,
    rgba(246, 176, 64, 1) 100%
  );
  background: -webkit-linear-gradient(
    to right,
    rgba(232, 113, 165, 1) 0%,
    rgba(246, 176, 64, 1) 100%
  );
  background: -o-linear-gradient(
    to right,
    rgba(232, 113, 165, 1) 0%,
    rgba(246, 176, 64, 1) 100%
  );
  background: -ms-linear-gradient(
    to right,
    rgba(232, 113, 165, 1) 0%,
    rgba(246, 176, 64, 1) 100%
  );
  background: linear-gradient(
    to right,
    rgba(232, 113, 165, 1) 0%,
    rgba(246, 176, 64, 1) 100%
  );
}
.container {
  margin-bottom: 3em;
}
.blue-text {
  color: #27aae1 !important;
}
.switch-plan {
  display: flex;
  justify-content: flex-end;
}
.account-links li {
  color: #27aae1;
  font-weight: 500;
}
.plan-details p {
  color: #939598 !important;
}

.billing-details li {
  color: #58595b;
}
#testButton {
  display: none;
}
</style>

<style scoped>
#analytics .select-wrapper {
  float: right !important;
  width: 175px !important;
  font-size: 14px !important;
}
#analytics .select-wrapper input.select-dropdown {
  height: 1.5em;
  line-height: 1.5em;
  font-size: 14px;
}
.analytics-buttons div {
  float: left;
}
.analytics-buttons .or {
  margin-left: 2em;
  margin-right: 2em;
  line-height: 36px;
}
.analytics-buttons .may-take {
  margin-top: 12px;
  display: block;
  max-width: 200px;
  font-size: 12px;
}
.plantext{
  font-size: 58px;
  font-weight: 700;
  color: #27282a;
  line-height: 68px;
  position: relative;
  top:-10px
}
.subplan{
  margin-left: auto;
    margin-right: auto;
    
    line-height: 24px;
    font-size:20px;
    color: #58595B;
}
.freetable {
  margin-left: auto;
  margin-right: auto;
  background-color:#27282A;
  border-radius: 5px
}

@media only screen and (max-width: 799px) {
  .talltable{
    display:none;
  }
  .widetable{
    display:'';
  }
}
@media only screen and (min-width: 800px) {
  .talltable{
    display:'';
  }
  .widetable{
    display:none;
  }
  .freetable{
    height: 100px;
    width: 800px;
  }
  .subplan {
    width: 26em;
  }
  #free1{
    width:20%;
    background-color:#27282A;
  }
  #free2{
    width:40%;
    background-color:#27282A;
  }
  #free3{
    width:30%;
    background-color:#27282A;
  }
}

.freetext {
  padding-left:18px;
  height: 47px;
  width: 79px;
  color: #FFFFFF;
  font-family: Roboto;
  font-size: 40px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 36px;
}
.create-a-beautiful {
  height: 38px;
  width: 327px;
  color: #FFFFFF;
  font-family: Roboto;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}
.fyifab {
  background-color: #000403; /* Green */
  border: none;
  color: white;
  font-size: 14px;
  cursor: pointer;
  border-radius: 30px;
  text-transform: capitalize;
  
}

.selectedPlanHeader {
  font-size: 58px;
  font-weight: bold;
  font-family: Roboto;
}
.itcosts {
  height: 24px;
  
  color: #58595B;
  font-family: Roboto;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 24px;
 
}
.yousavi {
  height: 29px;
  color: #27282A;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 24px;
  
}
/* Container holding the image and the text */
.xcontainer {
  position: relative;
  text-align: center;
  color: white;
}

/* Centered text */
.xcentered {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size:16pt;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/containers/dashboard/Settings.vue